export enum FeatureFlag {
	Account = 'Account',
}
